/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import LetterRecipientPicker from 'DesignSystem/LetterRecipientPicker/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Recipient/Content"
  
}) {
let letterValueData = fromData.useDataValue({ viewPath,
context: 'letter',
})
let externalProfessionalTemplatesValueData = fromData.useDataValue({ viewPath,
context: 'external_professional_templates',
})
let aggregateData = fromHelpers.isTemplateEligibleForExternalProfessional(letterValueData, externalProfessionalTemplatesValueData)
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'id',
})
let letterRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'recipient_id',
})
let letterPostalAddressIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'postal_address_id',
})
let onSave = fromHelpers.useOnSave({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<LetterRecipientPicker
  viewPath={`${viewPath}/LetterRecipientPicker`}
 autoSelect={true}
 data="letter"
 data="external_professional_templates"
 aggregate="helpers.js isTemplateEligibleForExternalProfessional"
 autoSelectExternalProfessional={aggregateData}
 data="patient.id"
 patientId={patientIdValueData}
 data="letter.recipient_id"
 recipientId={letterRecipientIdValueData}
 data="letter.postal_address_id"
 postalAddressId={letterPostalAddressIdValueData}
 onSave={onSave}
/>
{children}
</React.Fragment>)
}